import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from '../../../templates/services/base-service.template';
import { Core2Config } from '../../../utils/core2-config';
import { ApiVisa } from '../../../models/base/apivisa.model';
import { ApiResponseModel } from '../../../models/base/api-response.model';
import { getHttpHeader } from '../../../utils/http-header.factory';

@Injectable({
  providedIn: 'root'
})
export class PermissionCheckerService implements BaseService {

  public readonly apiUrl: string = Core2Config.TENANT_MICRO_URL_PREFIX + 'permissions/permission-check';
    
  constructor(protected readonly http: HttpClient) {}

  public checkPermission(perm_dfn_codes: string[], { api_domain_url, jwt_secret, tenantCode }: ApiVisa): Observable<ApiResponseModel<{ [code: string]: boolean }>>{
    return this.http.post<ApiResponseModel<{ [code: string]: boolean }>>(`${ api_domain_url }${ this.apiUrl }`, { perm_dfn_codes }, getHttpHeader(jwt_secret, tenantCode));
  }
}
